module.exports = __webpack_public_path__ + "img/football.88ca532a.jpg";